import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const HoursPanel = ({ hours, defaultExpanded = true }) => {
  
  return (
    <Accordion
      sx={{
        my: 2,
        '&::before': {
          display: 'none',
        },
      }}
      elevation={0}
      square
      defaultExpanded={defaultExpanded}
      TransitionProps={{ unmountOnExit: !defaultExpanded }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h5">Hours</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TableContainer>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row">
                  Monday
                </TableCell>
                {hours.monday_open ?
                  <TableCell align="right">
                    {hours.monday_open} - {hours.monday_close}
                  </TableCell> :
                  <TableCell align="right">
                    Closed
                  </TableCell>
                }
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Tuesday
                </TableCell>
                {hours.tuesday_open ?
                  <TableCell align="right">
                    {hours.tuesday_open} - {hours.tuesday_close}
                  </TableCell> :
                  <TableCell align="right">
                    Closed
                  </TableCell>
                }
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Wednesday
                </TableCell>
                {hours.wednesday_open ?
                  <TableCell align="right">
                    {hours.wednesday_open} - {hours.wednesday_close}
                  </TableCell> :
                  <TableCell align="right">
                    Closed
                  </TableCell>
                }
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Thursday
                </TableCell>
                {hours.thursday_open ?
                  <TableCell align="right">
                    {hours.thursday_open} - {hours.thursday_close}
                  </TableCell> :
                  <TableCell align="right">
                    Closed
                  </TableCell>
                }
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Friday
                </TableCell>
                {hours.friday_open ?
                  <TableCell align="right">
                    {hours.friday_open} - {hours.friday_close}
                  </TableCell> :
                  <TableCell align="right">
                    Closed
                  </TableCell>
                }
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Saturday
                </TableCell>
                {hours.saturday_open ?
                  <TableCell align="right">
                    {hours.saturday_open} - {hours.saturday_close}
                  </TableCell> :
                  <TableCell align="right">
                    Closed
                  </TableCell>
                }
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Sunday
                </TableCell>
                {hours.sunday_open ?
                  <TableCell align="right">
                    {hours.sunday_open} - {hours.sunday_close}
                  </TableCell> :
                  <TableCell align="right">
                    Closed
                  </TableCell>
                }
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
};

export default HoursPanel;
